<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TjP4lU/tc-custom/9781480499546.jpg?1733033197479" alt="This image is the cover for the book Chieftain, Telnarian Histories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chieftain, Telnarian Histories
      </h1>
      <p class="bookDescription body article font2">
        <p>A peasant is sent to the arena, fodder for the carnage—but before the horrified gaze of noble ladies, the warrior named Dog slaughters headsmen, hunters, and beasts to win freedom as a full‑fledged gladiator. Then deep‑space rebels attack an Empire ship where Dog performs combat killings for the amusement of the passengers, and the gladiator becomes a rebel. Now a beautiful officer of the court finds her life depends on the mercy of Dog, the man she ordered put to death! </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Norman
      </h2>
      
      <p class="authorDescription body article">John Norman is the creator of the Gorean Saga, the longest-running series of adventure novels in science fiction history. He is also the author of the science fiction series the Telnarian Histories, as well as <I>Ghost Dance</I>, <I>Time Slave</I>, <I>The Totems of Abydos</I>, <I>Imaginative Sex</I>, and <I>Norman Invasions</I>. Norman is married and has three children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?580e6a8b